import {Component, Input, OnInit} from '@angular/core';
import {WidgetData} from "../../../../../../../../core/shared/widget/widget-data";
import {WidgetFactory} from "../../../../../../../../core/shared/widget/service/widget.factory";

@Component({
    selector: 'bm-dunning-type-trigger-data',
    templateUrl: 'bm-dunning-type-trigger-data.component.html',
    standalone: false
})
export class BmDunningTypeTriggerDataComponent implements OnInit {

    @Input() dunningTypeTriggerId: number;
    dunningTypeTriggerData: WidgetData;

    ngOnInit() {
        this.refreshDataWidget();
    }

    refreshDataWidget() {
        this.dunningTypeTriggerData = WidgetFactory.createWidgetEntityData(
            'bm.dunning.object.shared.dunning.type.trigger.data',
            'Dunning Type Trigger',
            'bm.DunningTypeTrigger',
            this.dunningTypeTriggerId
        );
    }
}
